<template>
    <div>
        <header-nav :cur="6" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">问答</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">为您解答</div>
                        <div class="newbot">汇集知识碎片，解决学习难题</div>
                    </div>
                    <div class="input">
                        <img src="../../assets/img/question/icon_questions.svg" alt="" />
                        <div class="select" @click="showPopup">我要提问</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 问答 -->
      <div class="wd_cont">
        <img src="../../assets/img/question/ts_iconn.svg"/>
        <p>该板块暂未开放</p>
      </div>
<!--        <div class="navtab questbox">-->
<!--            <div class="answer" v-for="(item, index) in answerlist" :key="index">-->
<!--                <div class="img">-->
<!--                    <img src="../../assets/img/question/wenda_icon.svg" alt="" />-->
<!--                    问答-->
<!--                </div>-->
<!--                <div class="cont ignore">{{ item.content }}</div>-->
<!--                <div class="detail">-->
<!--                    <span class="time">时间：{{ item.createTime }}</span>-->
<!--                    <span class="todetail" @click="todetail(item.wid)">查看详情</span>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
   
        <!-- 我要提问,问答弹出框-->
        <van-popup v-model="show" closeable  v-if="loginstate==true">
            <div class="showbox">
                <div class="head">
                    <img src="../../assets/img/index/course.jpg" alt="" />
                    <div>
                        <div class="top">{{user.userName}}</div>
                        <div class="bot">我要提问</div>
                    </div>
                </div>
                <div class="textame">
                    <textarea v-model="content" maxlength="2000" placeholder="在学习的过程中有任何疑问都可以在这里提问......"></textarea>
                    <div class="num">0/2000</div>
                </div>
                <div class="reset" @click="commitData">提交</div>
            </div>
        </van-popup>
        <!-- 分页 -->
      <v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum' @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>

        <footer-nav />
    </div>
</template>
<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import pagination from '@/components/common/pagination'
export default {
    components: {
        'v-pagination': pagination,
        'header-nav':headerNav,
        'footer-nav':footerNav,
    },
    data() {
        return {
            show: false,
			answerlist:[],
			content:'',
			total:1,
			pageCount:1,
			pageSize:9,
			pageNum:1,
			loginstate:false,
			token:'',
			user:'',
			queryParams: {
			  pageNum: 1,
			  pageSize: 9,
			  articleTypeId:1,
			  courseName:null,
			  parentSubjectId:null,
			  subjectId:null,
			},
        };
    },
	created() {
		this.getList();
	},
	mounted() {
		this.confirmUser();
	},
    methods: {
		pagechange(currentPage){
			console.log(currentPage);
		    this.queryParams.pageNum=currentPage;
		    // ajax请求, 向后台发送 currentPage, 来获取对应的数据
		    this.getList();
		},
		getList(){
			this.$http.get(this.$api.url +'/papi/forum/list',{params:this.queryParams}).then((response) => {
			    this.answerlist=[];
			    this.answerlist = response.data.rows;	
				this.total = response.data.total;
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
		confirmUser(){
			this.token = localStorage.getItem('token');
			if(this.token == null || this.token ==''){
				this.loginstate = false;
				//this.$router.push('/login');
			}else{
			    this.queryLoginState();
		    }
		},
		queryLoginState(){
			this.token = localStorage.getItem('token');
			this.$http.get(this.$api.url +'/papi/user/queryLoginState',
			        {params:{'token':this.token}}).then((response) => {
			        var obj = response.data;
			        if(obj.code == 500){
						this.loginstate=false;
						//this.$router.push('/login');
						return;
					}
					if(obj.code == 200){
						this.loginstate=true;
						this.user = response.data.data.user;
					}
					console.log(obj);
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
		toright(index, name) {
		    this.activeindex = index;
		    this.name = name;
		},
		
		commitData(){
			if(this.content == null || this.content==''){
				alert('请填写您的问题');
				return;
			}
			this.$http.get(this.$api.url +'/papi/forum/add',
			   {params:{'content':this.content}}).then((response) => {
			   alert('提交成功');
			   this.content='';
			   this.show = false;
			   this.queryQuestion(1);
			   return;
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
        todetail(id) {
            this.$router.push({path:'/question/detail',query:{id:id}});
        },
        showPopup() {
			if(this.loginstate==false){
				this.$router.push('/login');
			}else{
				this.show = true;
			}  
        },
    },
};
</script>
<style lang="less" scoped> 
 // 公共
 .navtab {
     width: 1280px;
     margin: 0 auto;
 }
 .color {
     color: #2961EF !important;
 }
 .ignore {
     overflow: hidden;
     text-overflow: ellipsis;
     display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 2;
 }
 .ignore1 {
     overflow: hidden;
     text-overflow: ellipsis;
     display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 3;
 }
 // 搜索
 .nav {
     background: #f7f8fa;
     width: 100%;
     height: 177px;
     .top {
         display: block;
         font-size: 16px;
         font-weight: 300;
         color: #777777;
         padding: 19px 0 24px;
         .infor {
             color: #2961EF;
         }
     }
     .newbox {
         display: flex;
         justify-content: space-between;
         align-items: center;
         .newtop {
             font-size: 26px;
             color: #000000;
             margin-bottom: 5px;
         }
         .newbot {
             font-size: 16px;
             color: #888888;
         }
         .input {
             background: #2961EF;
             border-radius: 30px;
             width: 149px;
             height: 47px;
             display: flex;
             align-items: center;
             img {
                 margin-left: 10px;
                 margin-right: 20px;
             }
             .select {
                 font-size: 16px;
                 color: #ffffff;
                 background: none;
                 text-align: center;
             }
         }
     }
 }
 // 我要提问
 .van-popup {
     padding: 45px 32px;
     background: #ffffff;
     border-radius: 5px 5px 5px 5px;
     .head {
         display: flex;
         align-items: center;
         img {
             width: 63px;
             height: 63px;
             border-radius: 50%;
             margin-right: 15px;
         }
         .top {
             font-size: 16px;
             color: #000000;
         }
         .bot {
             font-size: 18px;
             font-weight: 600;
             color: #f17719;
         }
     }
     .textame {
         position: relative;
         margin-top: 29px;
         margin-bottom: 33px;
         textarea {
             font-size: 16px;
             color: #999999;
             padding: 17px 23px;
             background: #f7f8fa;
             width: 663px;
             height: 161px;
             border: 1px solid #e9e8f1;
             &::placeholder {
                 font-size: 16px;
                 color: #999999;
             }
         }
         .num {
             position: absolute;
             bottom: 9px;
             right: 19px;
             font-size: 16px;
             color: #999999;
         }
     }
     .reset {
         width: 148px;
         height: 45px;
         line-height: 45px;
         text-align: center;
         background: #2961EF;
         border-radius: 10px 10px 10px 10px;
         font-size: 16px;
         color: #ffffff;
         float: right;
     }
 }
 // 问答
 .questbox {
     display: flex;
     flex-wrap: wrap;
     margin-top: 26px;
     .answer {
         width: 29%;
         padding: 18px;
         background: #f7f8fa;
         border-radius: 5px 5px 5px 5px;
         margin-bottom: 22px;
         margin-right: 2%;
         &:nth-child(3n) {
             margin-right: 0;
         }
         .img {
             font-size: 18px;
             color: #777777;
             img {
                 width: 22px;
                 height: 17px;
             }
         }
         .cont {
             font-size: 18px;
             font-weight: 600;
             color: #333333;
             margin: 13px 0;
         }
         .quest {
             background: #ffffff;
             border-radius: 5px 5px 5px 5px;
             padding: 14px;
             .head {
                 font-size: 16px;
                 color: #999;
                 img {
                     width: 33px;
                     height: 33px;
                     border-radius: 50%;
                     vertical-align: middle;
                     margin-right: 6px;
                 }
                 span {
                     font-size: 16px;
                     font-weight: 600;
                     color: #666;
                 }
             }
             .content {
                 font-size: 16px;
                 font-weight: 300;
                 color: #777777;
                 margin-top: 14px;
             }
         }
         .detail {
             display: flex;
             justify-content: space-between;
             align-items: center;
             margin-top: 17px;
             .time {
                 font-size: 16px;
                 color: #777777;
             }
             .todetail {
                 cursor: pointer;
                 font-size: 16px;
                 color: #555555;
             }
         }
     }
 }
 
 .wd_cont{
     width: 800px;
     height: 400px;
     display: block;
     margin: 0 auto;
     img{
         width: 120px;
         height: auto;
         display: block;
         margin: 100px auto 0 auto;
         opacity: 0.5;
     }
     p{
         width: 100%;
         height: auto;
         line-height: 80px;
         font-size: 24px;
         font-weight: bold;
         color: #999;
         text-align: center;
         opacity: 0.7;
     }
 }
 
</style>
<style lang="less" scoped>
.paging {
    width: 534px;
    height: 50px;
    background: rgba(112, 112, 112, 0.18);
    border-radius: 37px 37px 37px 37px;
    margin: 35px auto;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #888888;
    justify-content: space-around;
    text-align: center;
    div {
        height: 50px;
        line-height: 50px;
        border-right: 1px solid rgba(112, 112, 112, 0.2);
        width: 20%;
        &:nth-child(5) {
            border: none;
        }
    }
}
</style>